import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { IoPlayCircleOutline } from "react-icons/io5";

import Wed22 from "./Images/Wed28.webp";
import Bab21 from "./Images/Bab21.webp";
import Mat9 from "./Images/Mat9.webp";
import Out9 from "./Images/Out9.webp";
import TagVedio1 from "./Images/TagVedio1.mp4";
import TagVedio2 from "./Images/TagVedio2.mp4";
import MyCarousel from "./Carousel";
import ImageSlider from "./ImageSlider";
import TagVedioposter1 from "./Images/TagVedioposter1.webp"
import TagVedioposter2 from "./Images/TagVedioposter2.webp"


import "./firstPage.css";
import EnquiryForm from "./EnquiryForm";

function FirstPage() {
  const bgImages = [Wed22, Bab21, Mat9, Out9];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [playingIndex, setPlayingIndex] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % bgImages.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [bgImages.length]);

  const handlePlay = (index) => {
    setPlayingIndex(index);
  };

  return (
    <>
      <div className="hero-section">
        {bgImages.map((img, index) => (
          <div
            key={index}
            className={`hero-bg ${index === currentIndex ? "active" : ""}`}
            style={{ backgroundImage: `url(${img})` }}
          ></div>
        ))}

        <div className="overlay-text">
          <h1>Tagme Photography</h1>
          <Link to="/home" className="view-portfolio-btn">
            View Portfolio
          </Link>
        </div>
      </div>

      <div className="image-slider-wrapper">
        <ImageSlider />
      </div>

      <div className="video-section">
        <div className="image-title">
          <h1>Stories Captured</h1>
        </div>

        <div className="video-wrapper right">
          {playingIndex === 0 ? (
            <video
              className="video-player"
              controls
              controlsList="nodownload"
              disablePictureInPicture
              onContextMenu={(e) => e.preventDefault()}
              autoPlay
            >
              <source src={TagVedio1} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <div className="video-thumbnail-container" onClick={() => handlePlay(0)}>
              <img
                src={TagVedioposter1}
                alt="Video thumbnail"
                className="video-thumbnail"
              />
              <IoPlayCircleOutline className="play-button-icon" />
            </div>
          )}
        </div>

        <div className="video-wrapper left">
          {playingIndex === 1 ? (
            <video
              className="video-player"
              controls
              controlsList="nodownload"
              disablePictureInPicture
              onContextMenu={(e) => e.preventDefault()}
              autoPlay
            >
              <source src={TagVedio2} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          ) : (
            <div className="video-thumbnail-container" onClick={() => handlePlay(1)}>
              <img
                src={TagVedioposter2}
                alt="Video thumbnail"
                className="video-thumbnail"
              />
              <IoPlayCircleOutline className="play-button-icon" />
            </div>
          )}
        </div>
      </div>

      <div className="imgcontainer">
        <div className="image-slider">
          <h1>A GLIMPSE OF OUR WORKS</h1>
          <p>Little Photo Magic</p>
        </div>
        <MyCarousel />
      </div>
      <EnquiryForm/>
    </>
  );
}

export default FirstPage;
